import types from "./types";
import service from "./service";

const login = (user, pass) => {
    return dispatch => {
        dispatch({
            type: types.LOGIN,
            payload: { user: { email: user } }
        });
        service.login(user, pass).then(result => {
                const { token, refresh_token } = result.data;
                dispatch(newToken({ token, refresh_token }, dispatch));
                delete result.data.token;
                delete result.data.refresh_token;
                dispatch(loginSuccess(result.data));
            })
            .catch(err => {
                return dispatch(loginFail(err));
            });
    };
};

const refresh = () => {
    return dispatch => {
        service
            .tokenRefresh()
            .then(result => dispatch(newToken(result.data)))
            .catch(() => dispatch(logOut()));
    };
};

const newToken = payload => ({
    type: types.NEW_TOKEN,
    payload
});

const loginSuccess = response => ({
    type: types.LOGIN_SUCCESS,
    payload: response
});

const token = () => {
    return (dispatch) => {
        dispatch({ type: types.LOGIN });
        return service.token().then(result => {
            if (result && result.data) {
                const { access_token, refresh } = result.data;
                dispatch(newToken({ token:access_token, refresh_token:refresh }));
                delete result.data.access_token;
                delete result.data.refresh;
                dispatch(loginSuccess(result.data.user));
            }
            return result;
        }).catch(error => {
            return dispatch(loginFail(error));
        });
    };
};

const loginFail = payload => ({
    type: types.LOGIN_FAIL,
    payload
});

const logOut = () => ({
    type: types.LOGOUT
});

export default {
    login,
    logOut,
    refresh,
    token,
};
